<ul class="nav__list">
    <li *ngFor="let item of navItems; trackBy: trackById">
        <div
            class="nav__item"
            [routerLink]="item.link"
            [routerLinkActive]="item.link ? 'active' : ''"
            [routerLinkActiveOptions]="{exact: item.exactMatch}"
            title="{{ item.label | i18next }}"
        >
            <a
                *ngIf="!item.children; else hasSubItems"
                [href]="item.link"
                class="nav__item-link"
                [ngClass]="{secure: item.secure}"
                [target]="item.target"
                (click)="onClickItem(item, $event)"
            >
                <div class="nav__item-icon">
                    <i [class]="item.iconClass"></i>
                </div>
                <div class="nav__item-text">
                    {{ item.label | i18next }}
                </div>
            </a>
            <ng-template #hasSubItems>
                <div
                    #navItemWithChild
                    class="nav__item-link nav__item-link--with-child"
                    [class.nav__item-link--expanded]="expandedItem === item"
                    (click)="onClickItemWidthChild(item, $event, navItemWithChild)"
                >
                    <div class="nav__item-icon">
                        <i [class]="item.iconClass"></i>
                    </div>
                    <div class="nav__item-text">
                        {{ item.label | i18next }}
                    </div>
                </div>
            </ng-template>
        </div>

        <animated-content [style.transitionDelay]="expandedItem !== item ? '0s' : ''" (heightContent)="animatedContentHeight = $event">
            <ul *ngIf="item.children && item.children.length && expandedItem?.id === item.id" class="nav__sublist">
                <ng-container *ngFor="let childItem of item.children">
                    <li class="nav__subitem txt-sm" *ngIf="!childItem.children; else hasSubItemsChild">
                        <div
                            *ngIf="!childItem.children"
                            [routerLink]="childItem.link"
                            [routerLinkActive]="'active'"
                            [routerLinkActiveOptions]="{exact: childItem.exactMatch}"
                            [queryParamsHandling]="childItem.queryParams"
                        >
                            <a
                                *ngIf="childItem.iconClass"
                                [href]="childItem.link"
                                [ngClass]="{secure: childItem.secure}"
                                [target]="childItem.target"
                                (click)="onClickItem(childItem, $event)"
                                class="nav__item-sublink"
                            >
                                <svg-image
                                    *ngIf="childItem.id === 'apps/appEdit'"
                                    class="nav__item-app-icon"
                                    [name]="childItem.iconClass"
                                ></svg-image>
                                {{ childItem.label | i18next }}
                                <sup *ngIf="childItem.sup">{{ childItem.sup }}</sup>
                            </a>
                        </div>
                    </li>

                    <ng-template #hasSubItemsChild>
                        <li class="nav__subitem nav__subitem--with-child txt-sm">
                            <div
                                #navItemWithChild
                                class="nav__item-sublink nav__item-sublink--title"
                                (click)="onClickItemWidthChild(childItem, $event, navItemWithChild)"
                            >
                                <svg-image
                                    *ngIf="childItem.id === 'apps/appEdit'"
                                    class="nav__item-app-icon"
                                    [name]="childItem.iconClass"
                                ></svg-image>
                                <div class="nav__item-text">
                                    {{ childItem.label | i18next }}
                                </div>
                            </div>
                            <ul *ngIf="childItem.children && childItem.children.length" class="nav__sublist">
                                <ng-container *ngFor="let subItem of childItem.children">
                                    <li
                                        [routerLink]="subItem.link"
                                        [routerLinkActive]="'active'"
                                        [routerLinkActiveOptions]="{exact: subItem.exactMatch}"
                                        [queryParamsHandling]="subItem.queryParams"
                                        class="nav__subitem txt-sm"
                                    >
                                        <a
                                            [href]="subItem.link"
                                            [target]="subItem.target"
                                            class="nav__item-sublink"
                                            (click)="onClickItem(subItem, $event)"
                                        >
                                            {{ subItem.label | i18next }}
                                            <sup *ngIf="subItem.sup">{{ subItem.sup | i18next }}</sup>
                                        </a>
                                    </li>
                                </ng-container>
                            </ul>
                        </li>
                    </ng-template>
                </ng-container>
            </ul>
        </animated-content>
    </li>
</ul>

<div class="nav__overlay" *ngIf="!navExpanded && expandedItem" (click)="closeExpandedMenu()"></div>
